import type { InventoryResource, Snapshot } from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import type { BackupVault } from '@/data/vaults/backupVault';

import { AwsEc2SnapshotRow } from './awsEc2SnapshotRow';
import { AzureVMSnapshotRow } from './azureVMSnapshotRow';
import { GcpVMSnapshotRow } from './gcpVMSnapshotRow';

export type RestoreActionType =
  | 'convert-snapshot'
  | 'convert-image'
  | 'volume'
  | 'full-instance';

export interface VMSnapshotRowProps {
  snap: Snapshot;
  vault: BackupVault | undefined;
  isSelected: boolean;
  onSelect: () => void;
  resource: InventoryResource;
  snapshotSelection: boolean;
}

export const VMSnapshotRow = (props: VMSnapshotRowProps) => {
  if (props.resource.cloudProvider === Provider.Azure) {
    return <AzureVMSnapshotRow {...props} />;
  }

  if (props.resource.cloudProvider === Provider.Aws) {
    return <AwsEc2SnapshotRow {...props} />;
  }

  if (props.resource.cloudProvider === Provider.Gcp) {
    return <GcpVMSnapshotRow {...props} />;
  }

  return null;
};
